/**
 * Shared animation constants for card scroll-triggered animations.
 */

/** Milliseconds of scroll idle before triggering animation */
export const SCROLL_IDLE_MS = 150;
